import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { employeeApi } from "../api/employee.api";
import { useAuthStore } from "@/app/store/auth.store";

export const MY_PHOTO_KEY = ["employees", "me", "photo-url"];

// The signed-in employee's own profile photo URL (null when none), shared
// by the Topbar avatar and the Your profile page. The backend signs it for
// an hour; refreshed well before that.
export function useMyPhotoUrl() {
  const hasEmployee = useAuthStore((s) => Boolean(s.user?.employeeId));
  const { data } = useQuery({
    queryKey: MY_PHOTO_KEY,
    queryFn: employeeApi.getMyPhotoUrl,
    enabled: hasEmployee,
    staleTime: 45 * 60 * 1000,
    refetchInterval: 45 * 60 * 1000,
    retry: false,
  });
  return data?.url || null;
}

export function useMyPhotoMutations({ onUploaded, onRemoved, onError } = {}) {
  const queryClient = useQueryClient();
  const refresh = (data) => {
    queryClient.setQueryData(MY_PHOTO_KEY, data);
    queryClient.invalidateQueries({ queryKey: ["employees"] });
    queryClient.invalidateQueries({ queryKey: ["employee-photo-url"] });
  };
  const upload = useMutation({
    mutationFn: employeeApi.uploadMyPhoto,
    onSuccess: (data) => { refresh(data); onUploaded?.(); },
    onError,
  });
  const remove = useMutation({
    mutationFn: employeeApi.removeMyPhoto,
    onSuccess: () => { refresh({ url: null }); onRemoved?.(); },
    onError,
  });
  return { upload, remove };
}
